/**
 * Type scale — one family (Instrument Sans), medium weight for headings,
 * regular for reading text. Pair each token with a color class at the call site.
 *
 * DISPLAY  — oversized uppercase: hero line, section headings, page titles
 * H2       — headings inside pages and dark panels
 * H3       — sub-headings, card titles, emphasized statements
 * LEAD     — intro/standfirst paragraphs
 * BODY     — all reading text
 * EYEBROW  — small uppercase labels, categories, meta labels
 * META     — dates, notes, captions
 */
export const DISPLAY_HEADING =
  // Below 640px the size eases down from 44px so single words like "RECEIPTS." still fit 320px screens
  "text-[clamp(2.25rem,11.5vw,2.75rem)] sm:text-[clamp(2.75rem,8.5vw,9.25rem)] font-medium uppercase leading-[0.88] tracking-[-0.03em]";

export const H2 = "text-[clamp(2.25rem,4vw,3.5rem)] font-medium leading-[1.05] tracking-[-0.025em]";

/** Headings inside dark feature panels share the H2 size. */
export const PANEL_HEADING = H2;

export const H3 = "text-[1.375rem] font-medium leading-snug tracking-[-0.01em] md:text-2xl";

export const LEAD = "text-xl leading-snug md:text-2xl";

export const BODY = "text-base leading-relaxed md:text-lg";

export const EYEBROW = "text-sm font-medium uppercase tracking-wide";

export const META = "text-sm";
